import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { injectDispatch } from '@ngrx/signals/events';
import {
  NumberInputComponent,
  CheckboxInputComponent,
} from '@navstation-portal/shared/ui/components';
import { IsVisibleDirective } from '@navstation-portal/shared/ui/directives';
import {
  AbstractStoreConnectedSectionComponent,
  offshorePositionAndWeatherEvents,
  OffshorePositionAndWeatherFormStore,
  OffshoreReportStore,
} from '@navstation-portal/reporting/data-access/offshore-report';

@Component({
  selector: 're-speed-and-distance',
  templateUrl: './speed-and-distance.component.html',
  imports: [
    IsVisibleDirective,
    FormsModule,
    NumberInputComponent,
    CheckboxInputComponent,
  ],
})
export class SpeedAndDistanceComponent extends AbstractStoreConnectedSectionComponent {
  tabId = 'positionAndWeather';
  sectionId = 'speedAndDistance';
  events = injectDispatch(offshorePositionAndWeatherEvents);
  positionAndWeatherStore = inject(OffshorePositionAndWeatherFormStore);
  offshoreReportStore = inject(OffshoreReportStore);
}
